export const useCrossSell = () => {

  const getItems = async (wareLinkedItems, wareGroups) => {

    const appConfig = useAppConfig();
    const locale = useLocale();

    let crossSellItems = [];

    if (wareLinkedItems) {
      crossSellItems = crossSellItems.concat(wareLinkedItems);
    }

    const crossSellSourceGroupId = wareGroups?.find(q => q.group.parents.find(qq => qq.id === appConfig.groupIds.snubniPrsteny || qq.id === appConfig.groupIds.zasnubniPrsteny))?.group.parents.find(q => q.id === appConfig.groupIds.snubniPrsteny || q.id === appConfig.groupIds.zasnubniPrsteny).id;

    if (crossSellSourceGroupId) {
      const crossSellTargetGroupId = crossSellSourceGroupId === appConfig.groupIds.snubniPrsteny ? appConfig.groupIds.krabickyNaSnubniPrsteny : appConfig.groupIds.krabickyNaZasnubniPrsteny;
      const crossSellItemsFromTargetGroup = (await useApiFetch(`/api/wareList?idGroup=${crossSellTargetGroupId}&take=10&currencyId=${locale.getLocale().currencyId}&languageId=${locale.getLocale().languageId}`)).data.value.wareList.wares.items;

      crossSellItems = crossSellItems.concat(crossSellItemsFromTargetGroup);
    }

    return crossSellItems;
  }


  return {
    getItems
  }
}